import React, {useEffect, useState} from 'react'
import TitreRapport from './titre_rapport.js'
import GraphAleasRapport from './graphAleas_Rapport.js'
import GraphAleasNBjoursRapport from './graphAleasNbjours_Rapport.js'
import GraphAleasNBjoursRapport2 from './graphAleasNbjours_Rapport2.js'
import apiLink from '../../config.js'
import FooterPDF from './footer.js'

function PageAleasPDF3({idExploit}) {
  const [ExploitMixte, setExploitMixte] = useState(false)
  const [ExploitViti, setExploitViti] = useState(false)
  const [ExploitGC,setExploitGC] = useState(true)

  const [dataMoy_GEL_2D, setDataMoy_GEL_2D] =  React.useState()
  const [dataMoy_GEL_4D, setDataMoy_GEL_4D] =  React.useState()
  const [dataMin_GEL_2D, setDataMin_GEL_2D] =  React.useState()
  const [dataMin_GEL_4D, setDataMin_GEL_4D] =  React.useState()
  const [dataMax_GEL_2D, setDataMax_GEL_2D] =  React.useState()
  const [dataMax_GEL_4D, setDataMax_GEL_4D] =  React.useState()
  const [dataQ1_GEL_2D, setDataQ1_GEL_2D] =  React.useState()
  const [dataQ1_GEL_4D, setDataQ1_GEL_4D] =  React.useState()
  const [dataQ3_GEL_2D, setDataQ3_GEL_2D] =  React.useState()
  const [dataQ3_GEL_4D, setDataQ3_GEL_4D] =  React.useState()
  const [dataNbjours_GEL_2D, setdataNbjours_GEL_2D] = React.useState()
  const [dataNbjours_GEL_4D, setdataNbjours_GEL_4D] = React.useState()
  const [dataNbjours_GEL_Max_2D, setNBJ_GEL_MAX_2D] = React.useState()
  const [dataNbjours_GEL_Max_4D, setNBJ_GEL_MAX_4D] = React.useState()
  const [dataNbjours_GEL_Min_2D, setNBJ_GEL_MIN_2D] = React.useState()
  const [dataNbjours_GEL_Min_4D, setNBJ_GEL_MIN_4D] = React.useState()

  function fetchData() {
    fetch(apiLink + 'page/production-rapport/' + idExploit)
    .then( (response) => {
    return response.json()
    })
    .then(response =>{
    let data = response
    for (var cle in data) {
        if (cle.includes("Vignes")) {
            setExploitMixte(true)
            setExploitGC(false)
            setExploitViti(false);
            break;
        }
    }
    let allKeysContainVignes = Object.keys(data).every(cle => cle.includes("Vignes"));
    if (allKeysContainVignes) {
        setExploitViti(true);
        setExploitMixte(false)
        setExploitGC(false)
    } else {
        setExploitViti(false);
    }
    })

    fetch('https://api2050.diagorisk.com/pageAleas/?idExploitation=' + idExploit + '&idProduction=none')
      .then((response) => response.json())
      .then((response) => {
        if ('error' in response) {
          // Si la réponse contient une erreur, relancer la requête après 60 secondes
          setTimeout(fetchData, 60000);
        } else {
          // Si la réponse est réussie, mettre à jour les données
          setDataMoy_GEL_2D(response.dataMoy_GEL_2D)
          setDataMoy_GEL_2D(prev => {
            return prev;
          })
          setDataMoy_GEL_4D(response.dataMoy_GEL_4D)
          setDataMoy_GEL_4D(prev => {
            return prev;
          })
          setDataMin_GEL_2D(response.dataMin_GEL_2D)
          setDataMin_GEL_2D(prev => {
            return prev;
          })
          setDataMin_GEL_4D(response.dataMin_GEL_4D)
          setDataMin_GEL_4D(prev => {
            return prev;
          })
          setDataMax_GEL_2D(response.dataMax_GEL_2D)
          setDataMax_GEL_2D(prev => {
            return prev;
          })
          setDataMax_GEL_4D(response.dataMax_GEL_4D)
          setDataMax_GEL_4D(prev => {
            return prev;
          })
          setDataQ1_GEL_2D(response.dataQ1_GEL_2D)
          setDataQ1_GEL_2D(prev => {
            return prev;
          })
          setDataQ1_GEL_4D(response.dataQ1_GEL_4D)
          setDataQ1_GEL_4D(prev => {
            return prev;
          })
          setDataQ3_GEL_2D(response.dataQ3_GEL_2D)
          setDataQ3_GEL_2D(prev => {
            return prev;
          })
          setDataQ3_GEL_4D(response.dataQ3_GEL_4D)
          setDataQ3_GEL_4D(prev => {
            return prev;
          })
          setdataNbjours_GEL_2D(response.dataNbjours_GEL_2D)
          setdataNbjours_GEL_2D(prev => {
            return prev;
          })
          setdataNbjours_GEL_4D(response.dataNbjours_GEL_4D)
          setdataNbjours_GEL_4D(prev => {
            return prev;
          })
          setNBJ_GEL_MAX_2D(response.dataNbjoursMax_GEL_2D)
          setNBJ_GEL_MAX_2D(prev => {
            return prev;
          })
          setNBJ_GEL_MAX_4D(response.dataNbjoursMax_GEL_4D)
          setNBJ_GEL_MAX_4D(prev => {
            return prev;
          })
          setNBJ_GEL_MIN_2D(response.dataNbjoursMin_GEL_2D)
          setNBJ_GEL_MIN_2D(prev => {
            return prev;
          })
          setNBJ_GEL_MIN_4D(response.dataNbjoursMin_GEL_4D)
          setNBJ_GEL_MIN_4D(prev => {
            return prev;
          })
        }
      })
      .catch((error) => {
        // Gérer les erreurs de la requête
        console.error('Erreur lors de la requête API :', error);
      });
  }
  useEffect ( () => {
    fetchData()
  }, [idExploit])
  
  return (
    <div className='containerPrint'>
      <TitreRapport Titre={'Impact du Gel'} Sous_Titre={"Sur toute l'exploitation"} Page={ExploitViti ? '5' : '7'}/>
      <div className='titreMoins row' style={{marginBottom:'20px', marginTop:'40px'}}> Niveau des risques de 2020 à 2050 </div>
      <div className='row' style={{width:'100%'}}>
        <div style={{width:'50%'}}>
          {dataMax_GEL_2D !== undefined ?<GraphAleasRapport myDataMax2D={dataMax_GEL_2D} myDataMax4D={dataMax_GEL_4D} aleas={'GEL'} print={true} dataType={"Val"} type={'Max'}/> :""}
        </div>
        <div style={{width:'50%'}}>
          {dataMoy_GEL_2D !== undefined ?<GraphAleasRapport myDataMoy2D={dataMoy_GEL_2D} myDataMoy4D={dataMoy_GEL_4D}  aleas={'GEL'} print={true} dataType={"Val"} type={'Moy'}/> :""}
        </div>
      </div>
      
      <div className='titreMoins row' style={{marginBottom:'20px', marginTop:'40px'}}> Evolution entre 2020 et 2050</div>
      <div className='row'  style={{width:'100%'}}>
        <div style={{width:'50%'}}>
          {dataMax_GEL_2D !== undefined ?<GraphAleasRapport myDataMax2D={dataMax_GEL_2D} myDataMax4D={dataMax_GEL_4D} aleas={'GEL'} print={true} dataType={"Diff"} type={'Max'}/> :""}
        </div>
        <div style={{width:'50%'}}>
          {dataMoy_GEL_2D !== undefined ?<GraphAleasRapport myDataMoy2D={dataMoy_GEL_2D} myDataMoy4D={dataMoy_GEL_4D}  aleas={'GEL'} print={true} dataType={"Diff"} type={'Moy'}/> :""}
        </div>
      </div>
      <FooterPDF idExploit={idExploit} top={'-20px'} />
    </div>
  )
}

export default PageAleasPDF3